import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Client } from 'src/pages/client-management/types/client.types';

export interface ActiveClientState {
  activeClient: Client | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: ActiveClientState = {
  activeClient: null,
  isLoading: false,
  error: null,
};

const activeClientSlice = createSlice({
  name: 'activeClient',
  initialState,
  reducers: {
    setActiveClient: (state, action: PayloadAction<Client | null>) => {
      state.activeClient = action.payload;
      state.error = null;
    },
    clearActiveClient: (state) => {
      state.activeClient = null;
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  setActiveClient,
  clearActiveClient,
  setLoading,
  setError,
} = activeClientSlice.actions;

export default activeClientSlice.reducer;
